export const ROOT_DOMAINS_REDUCER_NAME = 'rootDomains'
export const ROOT_DOMAINS_DATA_REDUCER_NAME = 'rootDomainsData'
export const CURRENT_ROOT_ID_REDUCER_NAME = 'currentRootId'

export const LOCALSTORAGE_SELECTED_ROOT = 'selectedRootId'
